<rk-page-configuration-container>
  <div content [class.pt-4]="podcastFeedUrls?.length > 0">
    <rk-setting-divider></rk-setting-divider>
    <div
      class="flex flex-col gap-6 px-7"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      [class.pt-10]="podcastFeedUrls?.length > 0"
    >
      @for (url of podcastFeedUrls; track url) {
        <div
          class="relative bg-white"
          cdkDrag
          cdkDragLockAxis="y"
          (cdkDragStarted)="dragStart()"
        >
          <div class="drag-placeholder" *cdkDragPlaceholder></div>
          <fa-icon
            class="text-[15px] opacity-20 w-6 flex cursor-grab absolute -left-[20px] top-[5px]"
            icon="grip-vertical"
            cdkDragHandle
          ></fa-icon>
          <rk-podcast-card [podcastFeedUrl]="url" [podcastFeedIndex]="$index">
          </rk-podcast-card>
        </div>
      }
    </div>
    <rk-add-podcast-button
      [podcastFeedListLength]="podcastFeedUrls?.length"
    ></rk-add-podcast-button>
  </div>
</rk-page-configuration-container>
